module.exports = "/_next/static/images/residencialMobile-564fcae2d7d0db149db1cfcef2249e38.svg";